var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7141 11.2799C9.71951 12.1438 8.42084 12.6666 7.00004 12.6666C3.87043 12.6666 1.33337 10.1296 1.33337 6.99998C1.33337 3.87037 3.87043 1.33331 7.00004 1.33331C10.1297 1.33331 12.6667 3.87037 12.6667 6.99998C12.6667 8.42086 12.1438 9.71961 11.2798 10.7142L14.5494 13.9838C14.7056 14.14 14.7056 14.3933 14.5494 14.5495C14.3932 14.7057 14.1399 14.7057 13.9837 14.5495L10.7141 11.2799ZM11.8667 6.99998C11.8667 9.68777 9.68783 11.8666 7.00004 11.8666C4.31225 11.8666 2.13337 9.68777 2.13337 6.99998C2.13337 4.31219 4.31225 2.13331 7.00004 2.13331C9.68783 2.13331 11.8667 4.31219 11.8667 6.99998Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkSearch);
export default __webpack_public_path__ + "static/media/DarkSearch.569e0e874b719d89593d12ad7c0c7f78.svg";
export { ForwardRef as ReactComponent };